import { ConsultationList } from './ConsultationList';
export default ConsultationList;
